import useViewModel from "./viewModel";
import View from "./view";

const Orders = () => {
  const viewModel = useViewModel();
  return <View {...viewModel} />;
};

export default Orders;
